import { TreeItem } from '@mui/lab';
import { useState, memo, useCallback } from 'react';
import NodeLabel from './NodeLabel';
import FeatureNode from './FeatureNode';
import { treeItemStyles } from '../utils/styles';
import { getComposeNodeId } from '../utils/helpers';

function TaxonomyNode({
  node,
  selectedNodeId,
  handleNodeSelect,
  handleAction,
  handleSaveFeature,
  levelMap,
  depth,
  maxDepth,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const composedNodeId = getComposeNodeId(node.id, node.level);

  const handleMenuClose = useCallback(() => setAnchorEl(null), []);
  const handleMenuOpen = useCallback(
    (event, nodeId) => {
      event.stopPropagation();
      handleNodeSelect(nodeId);
      setAnchorEl(event.currentTarget);
    },
    [handleNodeSelect],
  );

  return (
    <TreeItem
      nodeId={composedNodeId}
      label={(
        <NodeLabel
          node={node}
          composedNodeId={composedNodeId}
          anchorEl={anchorEl}
          selectedNodeId={selectedNodeId}
          handleNodeSelect={handleNodeSelect}
          handleMenuOpen={handleMenuOpen}
          handleMenuClose={handleMenuClose}
          handleAction={handleAction}
          levelMap={levelMap}
          depth={depth}
          maxDepth={maxDepth}
        />
      )}
      sx={treeItemStyles}
    >
      {node?.features?.length > 0 && (
        <FeatureNode
          node={node}
          selectedNodeId={selectedNodeId}
          handleNodeSelect={handleNodeSelect}
          handleSaveFeature={handleSaveFeature}
        />
      )}

      {node?.children?.length > 0 && (
        node.children.map((child) => (
          <TaxonomyNode
            key={child.id}
            node={child}
            selectedNodeId={selectedNodeId}
            handleNodeSelect={handleNodeSelect}
            handleAction={handleAction}
            handleSaveFeature={handleSaveFeature}
            levelMap={levelMap}
            depth={depth + 1}
            maxDepth={maxDepth}
          />
        ))
      )}
    </TreeItem>
  );
}

export default memo(TaxonomyNode);
